/**
 * API and WebSocket base URLs for cross-origin support.
 *
 * In development (Vite dev server), VITE_API_BASE_URL is empty so
 * all paths stay relative and go through Vite's proxy.
 *
 * In production on Cloudflare Pages, VITE_API_BASE_URL is set to
 * https://api.tradermap.io so all API/WS calls hit the backend domain.
 */

export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '';

export const WS_BASE_URL = (() => {
  const apiUrl = import.meta.env.VITE_API_BASE_URL;
  if (apiUrl) return apiUrl.replace(/^http/, 'ws');
  // In dev mode, check if proxy target is set (for connecting WS directly to prod)
  if (typeof __DEV_WS_TARGET__ !== 'undefined' && __DEV_WS_TARGET__) return __DEV_WS_TARGET__;
  return ''; // same-origin fallback
})();
